import { render, staticRenderFns } from "./MyPermissionPanel.vue?vue&type=template&id=5e5b30bc&scoped=true"
import script from "./MyPermissionPanel.vue?vue&type=script&lang=js"
export * from "./MyPermissionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b30bc",
  null
  
)

export default component.exports